// extracted by mini-css-extract-plugin
export var attribute = "styles-module--attribute--2a61a";
export var attributes = "styles-module--attributes--9809e";
export var buttons = "styles-module--buttons--d9acd";
export var container = "styles-module--container--9abe5";
export var content = "styles-module--content--b25c9";
export var image = "styles-module--image--ef40a";